import { UnitNumber, UnitType } from "@/types/unit";

export const parseNumberAndUnitFromRawValue = (
  rawValue: string | null,
  allowedUnits: UnitType[] = []
): [UnitNumber, UnitType | null, UnitNumber] => {
  if (!rawValue && rawValue !== "0") return [null, null, null];

  const trimmedValue = `${rawValue}`.trim();
  const unitMatch = trimmedValue.match(/[\d.\-+]*\s*(.*)/);

  const parsedNum = parseFloat(trimmedValue);
  const numToReturn = isFinite(parsedNum) ? parsedNum : null;

  const matchedUnit = unitMatch?.[1]?.toLowerCase();
  const foundUnit = allowedUnits.find(item => item === matchedUnit);
  const unitToReturn = foundUnit || null;
  const numMinusUnit = trimmedValue.replace(unitToReturn || "", "").trim();

  return [numToReturn, unitToReturn, numMinusUnit];
};

export const getStyleForUnit = (number: UnitNumber, unit: UnitType | null) => {
  if (unit === "custom") {
    // This could be any CSS Function, so we don't add the unit here.
    return number;
  } else if ((number && unit) || (number === 0 && unit)) {
    return `${number}${unit}`;
  } else if (number) {
    // For some reason if the unit is not set, but a number is present
    return number;
  } else if (unit === "auto") {
    return unit;
  } else if (unit) {
    // Don't output a style if only the unit is selected, this generates invalid CSS.
  }

  // Empty value
  return null;
};
